module.exports = __webpack_public_path__ + "static/media/purple-bg.95cf027b.png";